import React from 'react';
import styles from './styles.scss';

type Props = {
  label: ?string,
};

export default class LoadingSpinner extends React.Component<Props> {
  render() {
    return (
      <div className={styles.root}>
        <div className={styles.spinner}>
          <div />
        </div>
        {this.props.label && <div>{this.props.label}</div>}
      </div>
    );
  }
}
